import { TextField } from '@material-ui/core';
import styled from 'styled-components';

export const StyledTextField = styled(TextField)`
  width: 100%;
  margin: 10px 0 0 16px;
`;